import { Tooltip as AntTooltip } from 'antd';
import { TooltipPropsWithTitle } from 'antd/es/tooltip';
import { FC } from 'react';

interface Props extends TooltipPropsWithTitle {}

export const Tooltip: FC<Props> = props => {
	return <AntTooltip {...props} />;
};
